module.exports = __webpack_public_path__ + "static/img/05.d905ae6f.png";